module.exports = __webpack_public_path__ + "img/copy-outline.abf1d719.png";